import React, { useEffect, useState } from "react";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import "../Finance.css";
import "./Deposit.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalContext } from "../../../context/context";
import { createClient } from "@sanity/client";
import SelectPaymentMethod from "../../../widget/select-payment-method";
import { useForm } from "react-hook-form";
import { FiArrowDownCircle, FiArrowRight, FiCheckCircle, FiClock, FiInfo } from "react-icons/fi";

export const client = createClient({
  projectId: "gyh6ytch",
  dataset: "production",
  useCdn: true, // set to `false` to bypass the edge cache
  apiVersion: "2023-05-03", // use current date (YYYY-MM-DD) to target the latest API version
  // token: process.env.SANITY_SECRET_TOKEN // Only if you want to update content with the client
});

function Deposit() {
  const { userDetails, getUser, setWidget, widget } = useGlobalContext();
  const accessToken = JSON.parse(sessionStorage.getItem("accessToken"));
  const { firstName, symbol, country } = userDetails;

  const genSymbol = symbol === "" ? country?.symbol : symbol;
  const { register, watch } = useForm({ defaultValues: { amount: "" } });
  const { amount } = watch();

  const handleContinue = () => {
    if (amount !== "") {
      setWidget(!widget);
    } else {
      toast.error("Please put amount");
    }
  };

  useEffect(() => {
    getUser(accessToken);
  }, []);

  return (
    <section className="pg-finance-page pg-deposit-page">
      <div className="pg-finance-topbar"><DashboardHeader pathname={firstName} /></div>
      <main className="pg-finance-content">
        <header className="pg-finance-title">
          <div><span className="pg-finance-eyebrow">ACCOUNT SERVICES / DEPOSIT</span><h1>Add money</h1><p>Choose an amount, then follow the payment instructions shown for your account.</p></div>
          <span className="pg-finance-badge"><FiArrowDownCircle size={14} /> DEPOSIT</span>
        </header>
        <div className="pg-finance-layout pg-deposit-layout">
          <section className="pg-finance-panel pg-deposit-form-card" aria-labelledby="deposit-panel-title">
            <div className="pg-finance-panel-heading"><span className="pg-finance-icon"><FiArrowDownCircle size={20} /></span><div><span className="pg-finance-eyebrow">FUND YOUR ACCOUNT</span><h2 id="deposit-panel-title">Enter a deposit amount</h2></div></div>
            <p className="pg-deposit-amount-copy">Use numbers only. Your account currency is shown below.</p>
            <div className="pg-finance-field"><span>Amount</span><div className="pg-finance-money-entry">{genSymbol && <span aria-hidden="true">{genSymbol}</span>}<input type="number" min="0.01" step="any" inputMode="decimal" autoComplete="off" placeholder="0.00" aria-label="Deposit amount" {...register("amount")} /></div><small>Enter the amount you intend to deposit. Do not include a currency sign.</small></div>
            <div className="pg-deposit-account-currency"><span>Account currency</span><strong>{genSymbol || "Not set"}{country?.name ? " · " + country.name : ""}</strong></div>
            <button type="button" className="pg-finance-primary" onClick={handleContinue}>Continue to payment options <FiArrowRight size={15} /></button>
            <div className="pg-finance-note"><FiInfo size={15} /><span>Submitting payment details does not mean a deposit is approved. Check its status in Transactions.</span></div>
            <ToastContainer position="top-right" newestOnTop />
          </section>
          <aside className="pg-finance-aside pg-deposit-aside" aria-labelledby="deposit-overview-title">
            <span className="pg-finance-eyebrow">DEPOSIT OVERVIEW</span><h2 id="deposit-overview-title">Review before you continue</h2><p>Payment methods and instructions depend on the options enabled for your account.</p>
            <div className="pg-deposit-preview-amount"><span>Entered amount</span><strong>{genSymbol || ""}{Number.isFinite(Number(amount)) && Number(amount) > 0 ? Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}</strong></div>
            <ul className="pg-finance-aside-list"><li><FiCheckCircle size={15} /><span><strong>Choose a method</strong>Review the options available to your account.</span></li><li><FiInfo size={15} /><span><strong>Follow the instructions</strong>Use the payment details shown in the next step.</span></li><li><FiClock size={15} /><span><strong>Track the result</strong>Check Transactions for the deposit status before retrying.</span></li></ul>
          </aside>
        </div>
        <footer className="pg-finance-footer"><span>ProfitGrowing</span><span>Account services</span></footer>
      </main>
      {widget && <SelectPaymentMethod amount={amount} symbol={genSymbol} setWidget={setWidget} />}
    </section>
  );
}
export default Deposit;
